// Arena venues connect colored section overlays (e.g. `Section-L8`) next to real seats; they are not sellable places.
export const isSectionOverlayId = seatId => typeof seatId === 'string' && !seatId.includes('_')

export const countSellableSeats = seatIds => (seatIds || []).filter(seatId => !isSectionOverlayId(seatId)).length

export const isSharedTable = ticket => !!(
  ticket && ticket.itemMeta && ticket.itemMeta.table &&
  ticket.itemMeta.sharedTable && ticket.itemMeta.sharedTable.enabled
)

export const canFillSharedTableRemainder = (remaining, quantities) => {
  if (!Number.isInteger(remaining) || remaining < 0) return false

  const fillable = Array(remaining + 1).fill(false)
  fillable[0] = true
  for (let quantity = 1; quantity <= remaining; quantity++) {
    fillable[quantity] = quantities.some(allowed => allowed > 0 && quantity >= allowed && fillable[quantity - allowed])
  }

  return fillable[remaining]
}

// The order/batch limit restricts the package size, not the physical remainder.
export const getSharedTableQuantities = (ticket, availableCount, maxQuantity) => {
  if (!isSharedTable(ticket)) return []

  const { capacity, allowedQuantities } = ticket.itemMeta.sharedTable
  if (!Number.isInteger(capacity) || capacity < 1 ||
      Number(ticket.itemMeta.max) !== capacity ||
      !Number.isInteger(availableCount) || availableCount < 0 || availableCount > capacity ||
      !Array.isArray(allowedQuantities) || !allowedQuantities.length ||
      allowedQuantities.some(quantity => !Number.isInteger(quantity) || quantity < 1 || quantity > capacity)) return []

  return allowedQuantities.filter(quantity =>
    quantity <= maxQuantity && quantity <= availableCount &&
    canFillSharedTableRemainder(availableCount - quantity, allowedQuantities),
  )
}

export const isValidTableQuantity = (ticket, quantity, availableCount, maxQuantity = 40) => {
  if (!Number.isInteger(quantity) || quantity < 1 || quantity > maxQuantity) return false
  if (isSharedTable(ticket)) return getSharedTableQuantities(ticket, availableCount, maxQuantity).includes(quantity)

  const min = Math.max(1, Number(ticket.itemMeta.min) || 0)
  const max = Number(ticket.itemMeta.max)

  return Number.isInteger(max) && quantity >= min && quantity <= max
}
